import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  box: {
    width: '100%',
  },
  boxTitle: {
    fontSize: 20,
    fontWeight: 500,
    marginBottom: theme.spacing(3),
    textAlign: 'center',
  },
  titles: {
    fontSize: 20,
    textAlign: 'center',
    width: '290px',
    color: 'black',
    display: 'block',
    margin: '10px auto',
  },
  mainError: {
    display: 'flex',
    alignItems: 'center',
    height: '500px',
    justifyContent: 'center',
    gap: '70px',
    flexDirection: 'column',
  },
  paper: {
    backgroundColor: '#ffffff',
    padding: '40px',
    boxShadow: theme.shadows[0],
    width: 'calc(100% - 12px)',
    marginBottom: '80px',
  },
  rowWide: {
    position: 'relative',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(3.5),
  },
  row: {
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: theme.spacing(3.5),
  },
  title: {
    margin: theme.spacing(0, 3.5, 0, 0),
    fontSize: 14,
    letterSpacing: 0.15,
    color: 'rgb(0 0 0 / 54%)',
  },
  input: {
    width: 'calc(100%)',
    color: 'rgb(0 0 0 / 87%)',
  },
  inputError: {
    width: 'calc(100%)',
    color: 'rgb(0 0 0 / 87%)',
    marginBottom: theme.spacing(-2.8),
    '& label': {
      transform: 'translate(14px , 20px)',
      '& + div': {
        margin: 0,
      },
    },
  },
  btnBox: {
    display: 'flex',
    justifyContent: 'flex-start',
  },
  btn: {
    padding: theme.spacing(1, 2),
    fontSize: 14,
    textTransform: 'none',
  },
  btnWide: {
    padding: theme.spacing(1, 5),
    fontSize: 14,
    textTransform: 'none',
  },
  btnWideLeft: {
    padding: theme.spacing(1, 5),
    fontSize: 14,
    textTransform: 'none',
    marginRight: 10,
  },
  imgBox: {
    width: 136,
    padding: 0,
  },
  fieldsBox: {
    width: 'calc(100% - 140px)',
    paddingLeft: theme.spacing(4),
    paddingRight: 0,
  },
  tableBox: {
    width: '100%',
    padding: 0,
  },
  userImg: {
    width: 136,
    height: 136,
    background: 'linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #5081FF',
    borderRadius: 8,
    marginBottom: theme.spacing(2),
    overflow: 'hidden',
  },
  actionBox: {
    position: 'absolute',
    right: 0,
  },
  halfSizeRow: {
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(3.5),
  },
  link: {
    //alignItems: 'flex-grow',
    marginLeft: theme.spacing(7),
    display: 'flex',
    alignItems: 'flex-end',
    color: '#737373',
  },
  recaptcha: {
    transform: 'scale(1)',
    transformOrigin: '0 0',
  },
  captcha: {
    margin: '0 auto',
    display: 'table',
  },
  button: {
    width: '100%',
    marginTop: '20px',
    boxShadow: 'none',
    textTransform: 'none',
    lineHeight: '36px',
    padding: `8px 22px`,
  },
  buttonGrp: {
    width: '48%',
    margin: '20px 1% 0 1%',
    boxShadow: 'none',
    textTransform: 'none',
    lineHeight: '36px',
    padding: `8px 22px`,
  },
  buttonGrpSecondary: {
    width: '48%',
    margin: '20px 1% 0 1%',
    boxShadow: 'none',
    textTransform: 'none',
    lineHeight: '36px',
    padding: `8px 22px`,
    border: '1px solid rgba(0, 0, 0, 0.23)',
    borderRadius: '4px',
  },
  circle: {
    width: '24px',
    height: '24px',
    color: 'white',
    backgroundColor: '#5081FF',
    borderRadius: '50%',
    marginRight: '15px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '166%',
  },
  disabledCircle: {
    width: '24px',
    height: '24px',
    color: 'white',
    backgroundColor: 'rgba(0, 0, 0, 0.38);',
    borderRadius: '50%',
    marginRight: '15px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '166%',
  },
  activeText: {
    fontWeight: 500,
    fontsize: '14px',
    lineHeight: '157%',
    letterspacing: '0.1px',
    color: 'rgba(0, 0, 0, 0.87)',
  },
  disabledText: {
    fontWeight: 400,
    fontsize: '14px',
    lineHeight: '157%',
    letterspacing: '0.1px',
    color: 'rgba(0, 0, 0, 0.54);es',
  },
  flex: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '23%',
  },
  hr: {
    alignSelf: 'center',
    background: 'black',
    width: '100%',
    height: '1px',
  },
  horizontalLine: {
    width: '50%',
  },
  topBar: {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'space-evenly',
    margin: '60px 0',
  },
  icon: {
    fontSize: '14px',
  },
  borderClass: {
    backgroundColor: '#eee',
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
    '&.Mui-focused': {
      '& .MuiOutlinedInput-notchedOutline': {
        border: 'none',
      },
    },
  },
  alertmessage: {
    display: 'flex',
    borderRadius: '4px',
    margin: '0 auto',
    width: '500px',
    background: 'linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #F44336',
  },
  alertbox: {
    display: 'flex',
    padding: '8px 18px',
  },
  alertIcon: {
    marginRight: '10px',
    color: '#F44336',
  },
  alertTitle: {
    fontSize: '16px',
    lineHeight: '24px',
    fontWeight: 600,
    color: '#621b16',
  },
}));
